import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

const DeleteModal = ({ isOpen, toggle, onConfirm, item }) => {
  const [submitting, setSubmitting] = useState(false);

  const handleDelete = async () => {
    setSubmitting(true);
    try {
      await onConfirm(item);
      toggle();
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} backdrop="static">
      <ModalHeader toggle={toggle}>Hapus Register Usulan</ModalHeader>
      <ModalBody>
        Apakah Anda yakin ingin menghapus data ini?
        <div className="mt-2"><strong>{item?.nomorSurat}</strong> - {item?.namaPemohonLembagaPengusul}</div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle} disabled={submitting}>Batal</Button>
        <Button color="danger" onClick={handleDelete} disabled={submitting}>{submitting ? 'Menghapus...' : 'Hapus'}</Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteModal;


